import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import moment from "moment"

import { Tooltip } from "primereact/tooltip";
import { Sidebar } from 'primereact/sidebar';

import Table from '../../helpers/Table';
import SearchBar from './Components/SearchBar';

import Description from '../../common/Description';
import Loading from '../../common/Loading';
import CopyToClipboard from '../../common/CopyToClipboard';
import PMCompanyName from '../../common/PMCompanyName';
import ButtonGroup from '../../common/ButtonGroup';

import { fetchMaterialBrands, fetchMaterialCategories, fetchOrderTypesData } from '../../services/redux/reducers/commonThunk';
import { fetchSellerSearch, updateSearchParams, setIsSearchVisible } from "../../services/redux/reducers/sellerSearch/sellerSearch";

import { isMobile } from '../../utils';
import { DATE_FORMAT } from '../../constants';
import { useSearchPin } from '../../hooks/useSearchPin';


const SellerSearch = () => {
    const dispatch = useDispatch()
    const { isSearchPinned, toggleSearchPin, setSearchPin } = useSearchPin()
    
    const [isPageLoading, setIsPageLoading] = useState(false)
    const [isHoveringSearchZone, setIsHoveringSearchZone] = useState(false)
    const [hasEverHoveredRightEdge, setHasEverHoveredRightEdge] = useState(false)


    const paginationParams = useSelector(state => state.sellerSearchData.paginationParams)
    const searchParams = useSelector(state => state.sellerSearchData.searchParams)
    const sellerTransactionData = useSelector(state => state.sellerSearchData.sellerTransactionData)
    const isLoading = useSelector(state => state.sellerSearchData.loading)
    const isSearchVisible = useSelector(state => state.sellerSearchData.isSearchVisible)
    const isSearchActive = useSelector(state => state.sellerSearchData.isSearchActive)

    const brandData = useSelector((state) => state.common.materialBrands)
    const orderTypes = useSelector(state => state.common.orderTypes)

    const isMobileDevice = isMobile()

    useEffect(()=>{
        const currentDate = new Date()
        let fromDate  = currentDate.setMonth(currentDate.getMonth() -  3)
        fromDate = new Date(fromDate)
        let toDate = new Date()
        const updatedSearchParams = {...searchParams, fromDate: fromDate, toDate: toDate }
        dispatch(updateSearchParams({ ...updatedSearchParams}))

        dispatch(fetchMaterialBrands())
        dispatch(fetchMaterialCategories())
        dispatch(fetchOrderTypesData())
    }, [])

    useEffect(() => {
        if (!isSearchPinned && !isHoveringSearchZone) {
            dispatch(setIsSearchVisible(false))
        }

        const handleMouseMove = (e) => {
            if (isSearchPinned) return

            const panelWidth = window.innerWidth * 0.18
            const buffer = 8
            const screenRightEdge = window.innerWidth
            const activeZoneLeft = screenRightEdge - (panelWidth + buffer)

            if (e.clientX < activeZoneLeft) {
                setIsHoveringSearchZone(false)
                setHasEverHoveredRightEdge(false)
            } else {
                setIsHoveringSearchZone(true)
            }
        }

        if (!isSearchPinned && (isHoveringSearchZone || hasEverHoveredRightEdge)) {
            window.addEventListener('mousemove', handleMouseMove)
        }

        return () => {
            window.removeEventListener('mousemove', handleMouseMove)
        }
    }, [isSearchPinned, isHoveringSearchZone, hasEverHoveredRightEdge])

    const handlePageChange = async (e) => {
        let getSellerTransactionSearchParams = {
            ...searchParams,
            paginator: true,
            pageNo: e.page + 1,
            recordsPerPage: e.rows,
            limitedPagination: true,
            getCount: false,
        }
        if (getSellerTransactionSearchParams.searchBy !== "all") {
            getSellerTransactionSearchParams[getSellerTransactionSearchParams.searchBy] = getSellerTransactionSearchParams.searchText.trim()
        }
        dispatch(fetchSellerSearch({ ...getSellerTransactionSearchParams}))
    }

    const getBrandBody = (rowData) =>{
        const relatedBrand = brandData.find(eachBrand => eachBrand.brandId === rowData?.brandId)
        return (
            <div>
                {relatedBrand?.brandName}
            </div>
        )
    }

    const getOrderTypeBody = (rowData) =>{
        const relatedOrderType = orderTypes.find((eachOrderType) =>eachOrderType.orderTypeId === rowData?.orderTypeId )
        return (
            <div>
                {relatedOrderType?.orderType}
                <br />
                <span style={{ fontSize: '11px', color: 'gray' }}>
                    ({rowData?.isRouted ? 'ROUTED' : 'NOT ROUTED'})
                </span>
            </div>
        )
    }

    const getSellerInvoiceBody = (rowData)=>{
        return (
            <div>
                {rowData?.sellerInvoice}
                <br />
                <span style={{ fontSize: '12px', color: 'gray' }}>
                    {/* {rowData?.sellerInvoiceDate?.split('-').reverse().join('-')} */}
                    {moment(rowData?.sellerInvoiceDate).format(DATE_FORMAT)}
                </span>
            </div>
        )
    }

    const getSellerPhoneNumBody = (rowData) => {
        const { sellerPhoneNum, sellerEmailId } = rowData
        return (
            <>
                {sellerPhoneNum && (
                    <>
                        +{sellerPhoneNum.slice(0, 2)} {sellerPhoneNum.slice(2)}
                        <i className="pi pi-whatsapp pl-1 doc-copy-icon" onClick={() => window.open(`https://wa.me/${sellerPhoneNum}`)} />
                        <br />
                    </>
                )}
                {sellerEmailId && (
                    <span style={{ fontSize: '12px', color: 'gray' }}>
                        {sellerEmailId}
                        <CopyToClipboard text={sellerEmailId} />
                    </span>
                )}
            </>
        )
    }

    const getSellerCompanyNameBody = (rowData) => {
        console.log("row", rowData)
        let companyName = rowData.sellerCompanyName
        let companyId = rowData.sellerCompanyId
        return (
            <div>
                {/* <a href={`/company/${rowData.sellerCompanyId}`} target="_blank" rel="noopener noreferrer">
                    {rowData.sellerCompanyName}
                </a> */}
                <PMCompanyName companyName={companyName} companyId={companyId}/>
                <div style={{ fontSize: '12px', color: 'gray' }}>
                    ({rowData.sellerBranchName})
                </div>
            </div>
        )
    }

    const getSellerPONumber = (row) =>{
        return (
            <div className="text-center">
                <div className={`flex flex-row justify-content-center`}>
                    <p className='doc-no' style={{cursor : "pointer"}} onClick={() => window.open(`/sellerpo/${row?.sellerPOId}`, '_blank')}>{row?.sellerPONumber}</p>
                    <CopyToClipboard text={row?.sellerPONumber} />
                </div>
            </div>
        )
    }

    const getBuyerPONumBody = (row) => {
        const truncateText = (text, maxLength) => {
            if (text.length > maxLength) {
                return text.substring(0, maxLength) + '...'
            }
            return text
        }
    
        const truncatedPONum = truncateText(row?.buyerPONum || '', 20)
        const isTruncated = (row?.buyerPONum || '').length > 20
    
        return (
            <div className="text-center">
                <div className="flex flex-row justify-content-center">
                    <p
                        className={`doc-no custom-tooltip-${row?.buyerPOId}`}
                        style={{ cursor: "pointer" }}
                        onClick={() => window.open(`/buyerpo/${row?.buyerPOId}`, '_blank')}
                    >
                        {truncatedPONum}
                    </p>
                </div>
                {isTruncated && (
                    <Tooltip target={`.custom-tooltip-${row?.buyerPOId}`} position="top" autoHide>
                        <span>{row?.buyerPONum}</span>
                    </Tooltip>
                )}
            </div>
        )
    }

    const getProductSpecification = (row) => <Description text={row.productSpecification} maxLength={100}  width="300px" />

    const tableColumns = [
        {
            header: 'Seller Company Name',
            field: 'sellerCompanyName',
            body :  getSellerCompanyNameBody,
            style: { minWidth:"220px"}
        },
        {
            header: 'Seller City',
            field: 'sellerCity',
            style: { minWidth:"80px"}
        },
        {
            header: 'Seller PO Number',
            field: 'sellerPONumber',
            body: getSellerPONumber,
            style: { minWidth:"150px"}
        },
        {
            header: 'Material Id',
            field: 'materialId',
            style: { minWidth:"80px"}
        },
        {
            header: 'ERP Code',
            field: 'companyERPCode',
            style: { minWidth:"80px"}
        },
        {
            header: 'Seller Invoice',
            field: 'sellerInvoice',
            body : getSellerInvoiceBody,
            style: { minWidth:"110px"}
        },
        {
            header: 'Product Name',
            field: 'productName',
            style: { minWidth:"150px"}
        },
        {
            header: 'Product Specification',
            field: 'productSpecification',
            body: getProductSpecification,
            style: { minWidth:"220px"}
        },
        {
            header: 'Seller Unit Price',
            field: 'sellerUnitPrice',
            style: { minWidth:"90px"}
        },
        {
            header: 'Buyer Unit Price',
            field: 'buyerUnitPrice',
            style: { minWidth:"90px"}
        },
        {
            header: 'GST Rate',
            field: 'GST',
            style: { minWidth:"50px"}
        },
        {
            header: 'Buyer Company Name',
            field: 'buyerCompanyName',
            style: { minWidth:"190px"}
        },
        {
            header: 'Seller Phone/Email',
            field: 'sellerPhoneNum',
            body: getSellerPhoneNumBody,
            style: { minWidth:"190px"}
        },
        {
            header: 'BuyerPO Number',
            field: 'buyerPONum',
            body: getBuyerPONumBody,
        },
        {
            header: 'Brand Name',
            field: 'brandId',
            body: getBrandBody,
            style: { minWidth:"100px"}
        },
        {
            header: 'Order Type',
            field: 'orderTypeId',
            body : getOrderTypeBody
        }
    ]

    const handleSearchTabDisplay = () => {
        if (!isSearchPinned) {
          dispatch(setIsSearchVisible(!isSearchVisible))
        }
    }
    
    const actionButtons = [
        {
            icon: "pi pi-filter",
            label: "Filter",
            command: () => handleSearchTabDisplay(),
            className: isSearchActive ? "active-group-button" : ""
        },
        {
            icon: isSearchPinned ? "pi pi-lock" : "pi pi-lock-open",
            command: () => toggleSearchPin() 
        }
    ]

    let displaySearchBox = isSearchPinned || isHoveringSearchZone || isSearchVisible

    return (
        <div className='flex flex-column'>
            <Loading visible={isPageLoading} />
            <div
                onMouseEnter={() => {
                    if (!isSearchPinned) {
                        setIsHoveringSearchZone(true)
                        setHasEverHoveredRightEdge(true)
                        dispatch(setIsSearchVisible(true))
                    }
                }}
                style={{
                    position: 'fixed',
                    top: 0,
                    right: 0,
                    width: '8px',
                    height: '100vh',
                    zIndex: 999
                }}
            />
            <div className="flex flex-column md:flex-row md:justify-content-between">
                <h4 className="mx-2 my-1 md:m-2">SELLER TRANSACTIONS</h4>
                <div className="flex gap-2 justify-content-end mb-2">
                    {/* <Button icon="pi pi-filter" className={`h-2rem p-2 action-btn hover:surface-400 hover:text-700 surface-300 ${isSearchActive ? 'search-filter-active' : ''}`} label="Filter" onClick={handleSearchTabDisplay} /> */}
                    <ButtonGroup buttons={actionButtons} />
                </div>
            </div>

            <div className='flex flex-row'>
                <div className="approval-instances-table" style={{ order: "1", width: displaySearchBox && !isMobileDevice ? "82%" : "100%", maxHeight: "'calc(100%-100px)'" }}>
                    <div className='p-card mb-0' >
                        <div className="flex-grow-1" >
                            <Table
                                lazy
                                page={paginationParams.pageNo}
                                onPageChange={(e) => handlePageChange(e)}
                                totalRecords={paginationParams.totalRecords}
                                tableColumns={tableColumns}
                                data={sellerTransactionData}
                                rows={paginationParams.recordsPerPage}
                                scrollable={"true"}
                                scrollHeight="550px"
                                paginator
                                excessPagesFound={paginationParams.excessPagesFound}
                                loading={isLoading}
                            />
                        </div>
                    </div>
                </div>

                {displaySearchBox && (
                    <div
                        style={{ order: "2", width: "18%", paddingLeft: "10px" }} className="justify-content-end"
                        onMouseLeave={(e) => {
                            const bounds = e.currentTarget.getBoundingClientRect()
                            const leftExit = e.clientX < bounds.left
                            const topExit = e.clientY < bounds.top
                            const bottomExit = e.clientY > bounds.bottom

                            if (!isSearchPinned && (leftExit || topExit || bottomExit)) {
                                setIsHoveringSearchZone(false)
                                setHasEverHoveredRightEdge(false)
                            }
                        }}

                        onMouseEnter={() => {
                            if (!isSearchPinned) {
                                setIsHoveringSearchZone(true)
                            }
                        }}
                    >
                        <SearchBar />
                    </div>
                )}

                {/* {
                    isSearchVisible && !isMobileDevice &&
                    <div style={{ order: "2", width: "18%", paddingLeft: "10px" }} className="justify-content-end ">
                        <SearchBar />
                    </div>
                } */}
                 
                {
                    isSearchVisible && isMobileDevice && 
                    <div style={{ order: "2", width: "18%", paddingLeft: "10px" }} className="justify-content-end ">
                        <Sidebar position='right' visible={isSearchVisible} onHide={() => dispatch(setIsSearchVisible(false))}>
                            <SearchBar />
                        </Sidebar>
                    </div>
                }
            </div>
        </div>
    )
}

export default SellerSearch;
